import { request } from "./authApi";

// Public: no token needed, matches the backend's Section A /issues route.
// Returns issues newest (highest number) first.
export function getIssues() {
  return request("/issues");
}

// Admin only (Section C on the backend). formData must contain "number",
// "title" and an "image" file — sent as multipart, not JSON, since it
// carries a binary upload.
export function createIssue(token, formData) {
  return request("/issues", { method: "POST", body: formData, token });
}

export function updateIssue(token, id, formData) {
  return request(`/issues/${id}`, { method: "PUT", body: formData, token });
}

export function deleteIssue(token, id) {
  return request(`/issues/${id}`, { method: "DELETE", token });
}

// Public: matches the backend's Section A /issues/:id and
// /issue-topics/:id routes.
export function getIssue(id) {
  return request(`/issues/${id}`);
}

export function getIssueTopic(topicId) {
  return request(`/issue-topics/${topicId}`);
}

// Admin only (Section C). formData must contain "category",
// "title_fa"/"title_en", "description_fa"/"description_en",
// "body_fa"/"body_en", "byline_fa"/"byline_en", and optionally an
// "image" file — sent as multipart, not JSON, since it may carry a
// binary upload.
export function createIssueTopic(token, issueId, formData) {
  return request(`/issues/${issueId}/topics`, { method: "POST", body: formData, token });
}

export function updateIssueTopic(token, topicId, formData) {
  return request(`/issue-topics/${topicId}`, { method: "PUT", body: formData, token });
}

export function deleteIssueTopic(token, topicId) {
  return request(`/issue-topics/${topicId}`, { method: "DELETE", token });
}

// orderedTopicIds is every topic in this category section, in its new
// display order (see IssueTopicsPage.js's move up/down buttons).
export function reorderIssueTopics(token, issueId, category, orderedTopicIds) {
  return request(`/issues/${issueId}/topics/reorder`, {
    method: "PUT",
    token,
    body: { category, topic_ids: orderedTopicIds },
  });
}
